import { StringField } from 'vuex-orm-decorators'
import BaseModel from '@/data/models/BaseModel'

export type ReportingHistoricalTableGroupBy = 'years' | 'months' | 'days'

export class BaseReportingHistoricalTableModel extends BaseModel {
  @StringField()
  public date: string

  @StringField()
  public groupedBy: ReportingHistoricalTableGroupBy
}
